<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="size()"
  [attr.height]="size()"
  fill="currentColor"
>
  <use [attr.href]="href()"></use>
</svg>
